export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const CLEAR_USER = 'CLEAR_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'UPDATE_USER_ERROR';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const UPDATE_USER_DETAILS_SUCCESS = 'UPDATE_USER_DETAILS_SUCCESS';
export const UPDATE_USER_DETAILS_ERROR = 'UPDATE_USER_DETAILS_ERROR';
export const UPSERT_USER_ONBOARDING_PROFILE = 'UPSERT_USER_ONBOARDING_PROFILE';
export const UPSERT_USER_ONBOARDING_PROFILE_SUCCESS = 'UPSERT_USER_ONBOARDING_PROFILE_SUCCESS';
export const UPSERT_USER_ONBOARDING_PROFILE_ERROR = 'UPSERT_USER_ONBOARDING_PROFILE_ERROR';
export const UPSERT_COMPANY_ONBOARDING_PROFILE = 'UPSERT_COMPANY_ONBOARDING_PROFILE';
export const UPSERT_COMPANY_ONBOARDING_PROFILE_SUCCESS = 'UPSERT_COMPANY_ONBOARDING_PROFILE_SUCCESS';
export const UPSERT_COMPANY_ONBOARDING_PROFILE_ERROR = 'UPSERT_COMPANY_ONBOARDING_PROFILE_ERROR';
export const UPDATE_USER_ADDRESS = 'UPDATE_USER_ADDRESS';
export const UPDATE_ALL_USER_DATA = 'UPDATE_ALL_USER_DATA';
export const UPDATE_ALL_USER_DATA_SUCCESS = 'UPDATE_ALL_USER_DATA_SUCCESS';
export const UPDATE_ALL_USER_DATA_ERROR = 'UPDATE_ALL_USER_DATA_ERROR';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_ERROR = 'UPDATE_COMPANY_ERROR';
export const UPDATE_COMPANY_ADDRESS = 'UPDATE_COMPANY_ADDRESS';
export const UPDATE_COMPANY_ADDRESS_SUCCESS = 'UPDATE_COMPANY_ADDRESS_SUCCESS';
export const UPDATE_COMPANY_ADDRESS_ERROR = 'UPDATE_COMPANY_ADDRESS_ERROR';
export const UPDATE_ALL_COMPANY_DATA = 'UPDATE_ALL_COMPANY_DATA';
export const UPDATE_ALL_COMPANY_DATA_SUCCESS = 'UPDATE_ALL_COMPANY_DATA_SUCCESS';
export const UPDATE_ALL_COMPANY_DATA_ERROR = 'UPDATE_ALL_COMPANY_DATA_ERROR';
export const GET_BANK_ACCOUNT = 'GET_BANK_ACCOUNT';
export const GET_BANK_ACCOUNT_SUCCESS = 'GET_BANK_ACCOUNT_SUCCESS';
export const GET_BANK_ACCOUNT_ERROR = 'GET_BANK_ACCOUNT_ERROR';
export const GET_ON_RAMP_DEPOSITS = 'GET_ON_RAMP_DEPOSITS';
export const GET_ON_RAMP_DEPOSITS_SUCCESS = 'GET_ON_RAMP_DEPOSITS_SUCCESS';
export const GET_ON_RAMP_DEPOSITS_ERROR = 'GET_ON_RAMP_DEPOSITS_ERROR';
export const UPDATE_BANK_ACCOUNT = 'UPDATE_BANK_ACCOUNT';
export const UPDATE_BANK_ACCOUNT_SUCCESS = 'UPDATE_BANK_ACCOUNT_SUCCESS';
export const UPDATE_BANK_ACCOUNT_ERROR = 'UPDATE_BANK_ACCOUNT_ERROR';
export const SUBMIT_ONBOARDING = 'SUBMIT_ONBOARDING';
export const TRACK_ONBOARDING = 'TRACK_ONBOARDING';
export const SUBMIT_ONBOARDING_SUCCESS = 'SUBMIT_ONBOARDING_SUCCESS';
export const SUBMIT_ONBOARDING_ERROR = 'SUBMIT_ONBOARDING_ERROR';
export const GET_ONBOARDING_STATUS = 'GET_ONBOARDING_STATUS';
export const GET_ONBOARDING_STATUS_SUCCESS = 'GET_ONBOARDING_STATUS_SUCCESS';
export const GET_ONBOARDING_STATUS_ERROR = 'GET_ONBOARDING_STATUS_ERROR';
export const SET_ONBOARDING_PHONE_NUMBER = 'SET_ONBOARDING_PHONE_NUMBER';
export const SET_ONBOARDING_PHONE_NUMBER_SUCCESS = 'SET_ONBOARDING_PHONE_NUMBER_SUCCESS';
export const SET_ONBOARDING_PHONE_NUMBER_ERROR = 'SET_ONBOARDING_PHONE_NUMBER_ERROR';
export const SET_ONBOARDING_USER_TYPE = 'SET_ONBOARDING_USER_TYPE';
export const SET_ONBOARDING_USER_TYPE_SUCCESS = 'SET_ONBOARDING_USER_TYPE_SUCCESS';
export const SET_ONBOARDING_USER_TYPE_ERROR = 'SET_ONBOARDING_USER_TYPE_ERROR';
export const GET_TERMS_CONDITIONS = 'GET_TERMS_CONDITIONS';
export const GET_TERMS_CONDITIONS_SUCCESS = 'GET_TERMS_CONDITIONS_SUCCESS';
export const GET_TERMS_CONDITIONS_ERROR = 'GET_TERMS_CONDITIONS_ERROR';
export const ACCEPT_TERMS_CONDITIONS = 'ACCEPT_TERMS_CONDITIONS';
export const ACCEPT_TERMS_CONDITIONS_SUCCESS = 'ACCEPT_TERMS_CONDITIONS_SUCCESS';
export const ACCEPT_TERMS_CONDITIONS_ERROR = 'ACCEPT_TERMS_CONDITIONS_ERROR';
export const UPDATE_USER_NAMES = 'UPDATE_USER_NAMES';
export const UPDATE_USER_NAMES_SUCCESS = 'UPDATE_USER_NAMES_SUCCESS';
export const UPDATE_USER_NAMES_ERROR = 'UPDATE_USER_NAMES_ERROR';
export const UPDATE_INDIVIDUAL_COLLECT_DATA = 'UPDATE_INDIVIDUAL_COLLECT_DATA';
export const UPDATE_INDIVIDUAL_COLLECT_DATA_SUCCESS = 'UPDATE_INDIVIDUAL_COLLECT_DATA_SUCCESS';
export const UPDATE_INDIVIDUAL_COLLECT_DATA_ERROR = 'UPDATE_INDIVIDUAL_COLLECT_DATA_ERROR';
export const ADVANCE_ONBOARDING_STEP = 'ADVANCE_ONBOARDING_STEP';
export const ADVANCE_ONBOARDING_STEP_SUCCESS = 'ADVANCE_ONBOARDING_STEP_SUCCESS';
export const ADVANCE_ONBOARDING_STEP_ERROR = 'ADVANCE_ONBOARDING_STEP_ERROR';
export const GET_KYC_STATUS = 'GET_KYC_STATUS';
export const GET_KYC_STATUS_SUCCESS = 'GET_KYC_STATUS_SUCCESS';
export const GET_KYC_STATUS_ERROR = 'GET_KYC_STATUS_ERROR';
export const REQUEST_KYC = 'REQUEST_KYC';
export const REQUEST_KYC_SUCCESS = 'REQUEST_KYC_SUCCESS';
export const REQUEST_KYC_ERROR = 'REQUEST_KYC_ERROR';
export const GET_USER_PREFERENCES = 'GET_USER_PREFERENCES';
export const GET_USER_PREFERENCES_SUCCESS = 'GET_USER_PREFERENCES_SUCCESS';
export const GET_USER_PREFERENCES_ERROR = 'GET_USER_PREFERENCES_ERROR';
export const UPSERT_USER_PREFERENCES = 'UPSERT_USER_PREFERENCES';
export const UPSERT_USER_PREFERENCES_SUCCESS = 'UPSERT_USER_PREFERENCES_SUCCESS';
export const UPSERT_USER_PREFERENCES_ERROR = 'UPSERT_USER_PREFERENCES_ERROR';

export const getUser = () => ({
  type: GET_USER,
});

export const clearUser = () => ({
  type: CLEAR_USER,
});

export const updateUser = (payload) => ({
  type: UPDATE_USER,
  payload,
});

export const updateUserDetails = (payload) => ({
  type: UPDATE_USER_DETAILS,
  payload,
});

export const upsertUserOnboardingProfile = (payload) => ({
  type: UPSERT_USER_ONBOARDING_PROFILE,
  payload,
});

export const upsertCompanyOnboardingProfile = (payload) => ({
  type: UPSERT_COMPANY_ONBOARDING_PROFILE,
  payload,
});

export const updateUserAddress = (payload) => ({
  type: UPDATE_USER_ADDRESS,
  payload,
});

export const updateAllUserData = (payload) => ({
  type: UPDATE_ALL_USER_DATA,
  payload,
});

export const updateCompany = (payload) => ({
  type: UPDATE_COMPANY,
  payload,
});

export const updateCompanyAddress = (payload) => ({
  type: UPDATE_COMPANY_ADDRESS,
  payload,
});

export const updateAllCompanyData = (payload) => ({
  type: UPDATE_ALL_COMPANY_DATA,
  payload,
});

export const getBankAccount = () => ({
  type: GET_BANK_ACCOUNT,
});

export const getOnRampDeposits = (providers) => ({
  type: GET_ON_RAMP_DEPOSITS,
  payload: providers
    ? { providers: Array.isArray(providers) ? providers : [providers] }
    : {},
});

export const updateBankAccount = (payload) => ({
  type: UPDATE_BANK_ACCOUNT,
  payload,
});

export const submitOnboarding = () => ({
  type: SUBMIT_ONBOARDING,
});

export const submitOnboardingSuccess = () => ({
  type: SUBMIT_ONBOARDING_SUCCESS,
});

export const submitOnboardingError = (payload) => ({
  type: SUBMIT_ONBOARDING_ERROR,
  payload,
});

export const getOnboardingStatus = () => ({
  type: GET_ONBOARDING_STATUS,
});

export const setOnboardingPhoneNumber = (payload) => ({
  type: SET_ONBOARDING_PHONE_NUMBER,
  payload,
});

export const setOnboardingUserType = (payload) => ({
  type: SET_ONBOARDING_USER_TYPE,
  payload,
});

export const getTermsConditions = () => ({
  type: GET_TERMS_CONDITIONS,
});

export const acceptTermsConditions = (payload) => ({
  type: ACCEPT_TERMS_CONDITIONS,
  payload,
});

export const updateUserNames = (payload) => ({
  type: UPDATE_USER_NAMES,
  payload,
});

export const updateIndividualCollectData = (payload) => ({
  type: UPDATE_INDIVIDUAL_COLLECT_DATA,
  payload,
});

export const advanceOnboardingStep = (step) => ({
  type: ADVANCE_ONBOARDING_STEP,
  payload: step,
});

export const SAVE_COMPANY_COLLECT_DATA = 'SAVE_COMPANY_COLLECT_DATA';
export const SAVE_COMPANY_COLLECT_DATA_SUCCESS = 'SAVE_COMPANY_COLLECT_DATA_SUCCESS';
export const SAVE_COMPANY_COLLECT_DATA_ERROR = 'SAVE_COMPANY_COLLECT_DATA_ERROR';

export const saveCompanyCollectData = (payload) => ({
  type: SAVE_COMPANY_COLLECT_DATA,
  payload,
});

export const getKycStatus = () => ({ type: GET_KYC_STATUS });
export const requestKyc = () => ({ type: REQUEST_KYC });

export const getUserPreferences = () => ({
  type: GET_USER_PREFERENCES,
});

export const upsertUserPreferences = (payload) => ({
  type: UPSERT_USER_PREFERENCES,
  payload,
});
